<div class="chat-message" *ngIf="status !== 'DateGroup'; else groupDate" [ngClass]="{'return' : status === 'Declined', notAvatar: notAvatar}">
  <div class="chat-message__wrapper">
    <div class="chat-message__image">
      <div class="image" *ngIf="!notAvatar" [style.background-color]="title | firstLetters | avatarColor"><span>{{title | firstLetters}}</span></div>
    </div>
    <div class="chat-message__info">
      <div class="head">
        <div class="name">{{title}}</div>
        <div class="date">{{date | dateMessage}}</div>
        <div class="status" [ngClass]="status">
          <app-chat-message-status [status]="status"></app-chat-message-status>
        </div>
      </div>
      <div class="content content--text" [ngClass]="{'isNotRead': !isRead}" *ngIf="text" [innerText]="text"></div>
      <div class="content content--images" *ngIf="images?.length">
        <div class="image-list">
          <ng-container *ngIf="images.length > 1">
            <div class="image" (click)="openGallery(0)">
              <img [src]="images[0].AttachThumbURL" [alt]="images[0].AttachName">
            </div>
            <div class="image" (click)="openGallery(1)" [ngClass]="{'image--more': images.length > 2}">
              <img [src]="images[1].AttachThumbURL" [alt]="images[1].AttachName">
              <span *ngIf="images.length > 2">+{{images.length - 1}}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="images.length === 1">
            <div class="image" (click)="openGallery(0)">
              <img [src]="images[0].AttachThumbURL" [alt]="images[0].AttachName">
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #groupDate>
  <div class="dateGroup">
    <div class="dateGroup__wrapper">{{text}}</div>
  </div>
</ng-template>
